import { createContext, useState } from 'react';

export interface AiFeedbackVisibilityContextType {
  showAiFeedback: boolean;
  setShowAiFeedback: (show: boolean) => void;
}

export const AiFeedbackVisibilityContext = createContext<AiFeedbackVisibilityContextType | null>(null);

export const AiFeedbackVisibilityProvider = ({ children }: { children: React.ReactNode }) => {
  const [showAiFeedback, setShowAiFeedback] = useState<boolean>(false);

  return (
    <AiFeedbackVisibilityContext.Provider value={{ setShowAiFeedback, showAiFeedback }}>
      {children}
    </AiFeedbackVisibilityContext.Provider>
  );
};
